import { MatchEvent } from "../matchEvent";
import { EventName } from "../enums/eventName";

export class StoppageEvent extends MatchEvent {
    // Set when the referee stops the stoppage timer; absent while it's running
    endTime?: number;

    constructor(
        timestamp: number,
        eventName: EventName,
        half: number,
        minuteOfPlay: number,
        endTime?: number
    ) {
        super(timestamp, eventName, half, minuteOfPlay);
        this.endTime = endTime;
    }

    static fromJSON(
        json: Pick<
            StoppageEvent,
            "timestamp" | "eventName" | "half" | "minuteOfPlay" | "endTime"
        >
    ) {
        return new StoppageEvent(
            json.timestamp,
            json.eventName,
            json.half,
            json.minuteOfPlay,
            json.endTime
        );
    }
}
